import React, { useMemo } from 'react';
import { CustomInput } from '../Components/CustomFormElements';

function RecordRouteConnectionObjectMapping({
  title,
  side,
  connectionObject,
  mapping = {},
  onChange,
  isDisabled = false,
}) {
  const attributes = useMemo(() => {
    const arr = connectionObject?.schema_object?.object_attributes;
    if (!Array.isArray(arr)) return [];
    return arr;
  }, [connectionObject]);

  const handleChange = (attrName, sysProp) => {
    const next = { ...(mapping || {}) };
    if (!sysProp || !sysProp.trim()) {
      delete next[attrName];
    } else {
      next[attrName] = sysProp;
    }
    onChange && onChange(next);
  };

  if (!connectionObject) {
    return null;
  }

  return (
    <div className="int-col-2 p-2 border-yes radius-yes bg-yes" style={{ marginTop: 12 }}>
      {title && (
        <h4 className="h4-title" style={{ marginBottom: 8 }}>
          {title} {side ? `(${side})` : null}
        </h4>
      )}

      {attributes.length === 0 ? (
        <div className="small-font text-muted">No attributes in selected connection object.</div>
      ) : (
        <div className="d-flex flex-column gap-2">
          <div className="term-header-row">
            <div className="term-keyword">Connection attribute</div>
            <div className="term-definition">System property (destination)</div>
          </div>

          <div
            style={{
              maxHeight: attributes.length > 8 ? 360 : 'auto',
              overflowY: attributes.length > 8 ? 'auto' : 'visible',
            }}
          >
            {attributes.map((attr) => {
              const attrName = attr.attribute_name;
              const current = mapping?.[attrName] ?? '';

              return (
                <div key={attrName} className="term-item" style={{ alignItems: 'center' }}>
                  <div className="term-keyword">
                    <div>
                      <strong>{attrName}</strong>
                    </div>
                    <div className="small-font">{attr.attribute_type}</div>
                  </div>
                  <div
                    className="term-definition"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <CustomInput
                      id={`${side || 'mapping'}-map-${attrName}`}
                      label=""
                      placeholder="system.property.path (e.g. lead.phone)"
                      value={current}
                      onChange={(_, v) => handleChange(attrName, v)}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="small-font" style={{ opacity: 0.8, marginTop: 6 }}>
            Tip: you can map to a custom path (free text), e.g. <code>lead.email</code>,{' '}
            <code>buyer.phone</code>, <code>process.stage</code>.
          </div>
        </div>
      )}
    </div>
  );
}

export default RecordRouteConnectionObjectMapping;
